export const apiBaseDomain = 'https://api.lipeiran.dev';
